import {useContext} from "react";
import UIContext from "../contexts/ui.context";

const useUI = () => {
  return useContext(UIContext);
};

export default useUI;